import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import HelpFeedback from './HelpFeedback';
import './HelpArticle.css';

export default function HelpArticle({ title, content }) {
  // Extract article ID from title for feedback tracking
  const articleId = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <article className="help-article">
      <h1>{title}</h1>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      <HelpFeedback articleId={articleId} />
    </article>
  );
}
